/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Plugin_ExtensionInputs */

const en_val_plugin_extension = /** @type {(inputs: Val_Plugin_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plugin / Extension`)
};

const es_val_plugin_extension = /** @type {(inputs: Val_Plugin_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plugin / Extensión`)
};

const fr_val_plugin_extension = /** @type {(inputs: Val_Plugin_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plugin / Extension`)
};

const de_val_plugin_extension = /** @type {(inputs: Val_Plugin_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plugin / Erweiterung`)
};

const ja_val_plugin_extension = /** @type {(inputs: Val_Plugin_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プラグイン / 拡張機能`)
};

const zh_val_plugin_extension = /** @type {(inputs: Val_Plugin_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插件 / 扩展程序`)
};

const ar_val_plugin_extension = /** @type {(inputs: Val_Plugin_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إضافة / امتداد`)
};

const id_val_plugin_extension = /** @type {(inputs: Val_Plugin_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plugin / Ekstensi`)
};

const it_val_plugin_extension = /** @type {(inputs: Val_Plugin_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plugin / Estensione`)
};

const ru_val_plugin_extension = /** @type {(inputs: Val_Plugin_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Плагин / Расширение`)
};

const pt_val_plugin_extension = /** @type {(inputs: Val_Plugin_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plugin / Extensão`)
};

const ko_val_plugin_extension = /** @type {(inputs: Val_Plugin_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`플러그인 / 확장 프로그램`)
};

/**
* | output |
* | --- |
* | "Plugin / Extension" |
*
* @param {Val_Plugin_ExtensionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_plugin_extension = /** @type {((inputs?: Val_Plugin_ExtensionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Plugin_ExtensionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_plugin_extension(inputs)
	if (locale === "es") return es_val_plugin_extension(inputs)
	if (locale === "fr") return fr_val_plugin_extension(inputs)
	if (locale === "de") return de_val_plugin_extension(inputs)
	if (locale === "ja") return ja_val_plugin_extension(inputs)
	if (locale === "zh") return zh_val_plugin_extension(inputs)
	if (locale === "ar") return ar_val_plugin_extension(inputs)
	if (locale === "id") return id_val_plugin_extension(inputs)
	if (locale === "it") return it_val_plugin_extension(inputs)
	if (locale === "ru") return ru_val_plugin_extension(inputs)
	if (locale === "pt") return pt_val_plugin_extension(inputs)
	return ko_val_plugin_extension(inputs)
});